// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1tTbv","paramInput":"JobSimulator_paramInput__3cLy4","input":"JobSimulator_input__1dENn"};